/* eslint react/no-did-mount-set-state: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import Client from "../Client";

class RemoteSignIn extends React.Component {
  state = {
    credentials: {},
    isLoggedIn: false,
    error: false
  };

  componentDidMount() {
    const search = this.props.location.search;
    const attributes = search.split("?")[1].split("&");
    const credentials = {};
    attributes.forEach(attribute => {
      if (attribute.includes("user_id=")) {
        const data = attribute.split("user_id=");
        credentials.user_id = data[1];
        return;
      }

      if (attribute.includes("nonce=")) {
        const data = attribute.split("nonce=");
        credentials.nonce = data[1];
        return;
      }

      if (attribute.includes("timestamp=")) {
        const data = attribute.split("timestamp=");
        credentials.timestamp = data[1];
        return;
      }

      if (attribute.includes("hmac=")) {
        const data = attribute.split("hmac=");
        credentials.hmac = data[1];
      }
    });
    this.setState({ credentials });
    Client.getAuth(credentials)
      .then(() => this.setState({ isLoggedIn: true }))
      .catch(() => this.setState({ error: true }));
  }

  render() {
    if (this.state.isLoggedIn) {
      return <Redirect to="/runsheets" />;
    }

    if (this.state.error) {
      return <div>Error logging in</div>;
    }

    return (
      <div>
        <p>Signing in...</p>
      </div>
    );
  }
}
RemoteSignIn.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

export default RemoteSignIn;



// WEBPACK FOOTER //
// ./src/components/RemoteSignIn.js